export const stripFe0fList = [
    '🗞️',
    '🌶️',
    '👁️',
    '🛢️',
    '❄️',
    '☦️',
    '✍️',
    '🗄️',
    '☀️',
    '⚙️',
    '♣️',
    '✂️',
    '☢️',
    '♠️',
    '♥️',
    '🗺️',
    '⛸️',
    '❤️',
    '🏎️',
    '🏍️',
    '✝️',
    '🖍️',
    '🌪️',
    '🍽️',
    '🖼️',
    '🎛️',
    '🕉️',
    '⚖️',
    '🕹️',
    '🏛️',
    '🎟️',
    '⚰️',
    '☯️',
    '🏕️',
    '✉️',
    '🏟️',
    '✈️',
    '⛰️',
    '⚜️',
    '🕯️',
    '☠️',
    '♟️',
    '⚠️',
    '🕳️',
    '🎖️',
    '🕸️',
    '🛍️',
    '✏️',
    '☁️',
    '✡️',
    '🕷️',
    '⛓️',
    '♻️',
    '🏖️',
    '☸️',
    '🖨️',
    '☄️',
    '🗡️',
    '☪️',
    '✌️',
    '🛋️',
    '🛡️',
    '⚛️',
    '🗑️',
    '♾️',
];
